const ACTION_SUBJECT_TAG = '[Error]';

export class DisplayFullScreenError {
  static readonly type = `${ACTION_SUBJECT_TAG} Display full-screen error`;

  constructor(public message: string, public sourceRoute: string) {}
}
